import XApi from "../../utils/Api";
import XEndpoints from "../../core/config/Endpoints";

export class PurchaseService {
    // Purchase
    async addPurchase(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.purchase, data, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updatePurchase(id: number, data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.purchase}/detail/${id}`, data, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async getPurchase(id: number) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.purchase}/detail/${id}`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async exportPurchase(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(`${XEndpoints.purchase}/export`, data, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? null;
        }
        return null;
    }

    // Return
    async addPurchaseReturns(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.purchaseReturn, data, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updatePurchaseReturn(id: number, data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.purchaseReturn}/detail/${id}`, data, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async getPurchaseReturn(id: number) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.purchaseReturn}/detail/${id}`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async exportPurchaseReturn(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(`${XEndpoints.purchaseReturn}/export`, data, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? null;
        }
        return null;
    }
}